module.exports = __webpack_public_path__ + "img/index_slide_main.9cadeae3.png";